// extracted by mini-css-extract-plugin
module.exports = {"text_icon":"Texticon--text_icon--3aKLo","icon_heading":"Texticon--icon_heading--vOYKW"};